import VueRouter from 'vue-router'


import ChatHome from '../view/pages/chatHome/index.vue'
import ChatWindow from '../view/pages/chatHome/chatwindow.vue'
import LoginPage from "../view/login/index.vue"
import registerPage from "../view/register/index.vue"
export default new VueRouter({
    routes: [
        {
            path: "/",
            redirect: "/ChatHome",
        },
        {
            path: "/ChatHome",
            name: "ChatHome",
            component: ChatHome,
        },
        // 登录
        {
            path: '/login',
            name: 'login',
            component: LoginPage
        },

        // 注册
        {
            path: '/register',
            name: 'register',
            component: registerPage
        }

    ]
})